module.exports = __webpack_public_path__ + "img/CHE.c43732e9.svg";